import QRCode from 'qrcode';
import { useEffect, useState } from 'react';

// Renders a real scannable QR code as a PNG <img>. The encoding runs in an
// effect (qrcode.toDataURL is async) and is keyed on value+size so the data URL
// is only regenerated when one of them changes. An empty value renders nothing.
export function LvaQrCode({ value, size }: { value: string; size?: number }) {
  const width = size ?? 120;
  const [dataUrl, setDataUrl] = useState<string | null>(null);

  useEffect(() => {
    if (!value) return;
    let active = true;
    QRCode.toDataURL(value, { margin: 1, width })
      .then((url) => {
        if (active) setDataUrl(url);
      })
      .catch(() => {
        if (active) setDataUrl(null);
      });
    return () => {
      active = false;
    };
  }, [value, width]);

  if (!value || !dataUrl) return null;
  return <img alt="QR" src={dataUrl} width={width} height={width} />;
}
